import { render, staticRenderFns } from "./SubtitlesNav.vue?vue&type=template&id=29c22d4d&scoped=true&"
import script from "./SubtitlesNav.vue?vue&type=script&lang=js&"
export * from "./SubtitlesNav.vue?vue&type=script&lang=js&"
import style0 from "./SubtitlesNav.vue?vue&type=style&index=0&id=29c22d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c22d4d",
  null
  
)

export default component.exports